import { css, useTheme } from "@emotion/react"
import {
  breakpoints,
  colorPrimatives,
  fontFamilies,
  fontSizes,
  mediaQueries,
} from "../styles/theme"
import Text from "../styles/typography"

export default () => {
  const theme = useTheme()
  return (
    <div
      css={css`
        margin: 3rem auto;
        text-align: center;
        ${mediaQueries.sm} {
          padding: 0 4ch;
        }
      `}
    >
      <Text
        lang="ar"
        css={css`
          ${mediaQueries.sm} {
            font-size: ${fontSizes.md};
          }
        `}
      >
        ﷽
      </Text>
      <Text
        css={css`
          color: ${theme.color.quote};
          margin-top: 1em;
          font-size: ${fontSizes.xs};
          ${mediaQueries.sm} {
            font-size: ${fontSizes.sm};
          }
        `}
      >
        In the Name of Allah, the Most Compassionate, the Most Merciful.
      </Text>
    </div>
  )
}
